package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.GroupW500Rounded: ImageVector
    get() {
        if (_groupW500Rounded != null) {
            return _groupW500Rounded!!
        }
        _groupW500Rounded = Builder(name = "GroupW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(32.59f, 691.59f)
                quadToRelative(0.0f, -36.23f, 18.74f, -66.59f)
                quadToRelative(18.74f, -30.37f, 49.8f, -46.35f)
                quadToRelative(62.72f, -31.24f, 127.66f, -46.98f)
                quadToRelative(64.95f, -15.74f, 131.93f, -15.74f)
                quadToRelative(67.43f, 0.0f, 132.39f, 15.62f)
                quadToRelative(64.96f, 15.62f, 127.19f, 46.86f)
                quadToRelative(31.06f, 15.95f, 49.81f, 46.25f)
                quadToRelative(18.74f, 30.3f, 18.74f, 66.93f)
                verticalLineToRelative(29.61f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                reflectiveQuadToRelative(-64.39f, 26.61f)
                lineTo(123.59f, 812.2f)
                quadToRelative(-37.79f, 0.0f, -64.39f, -26.61f)
                quadToRelative(-26.61f, -26.61f, -26.61f, -64.39f)
                verticalLineToRelative(-29.61f)
                close()
                moveTo(836.41f, 812.2f)
                horizontalLineToRelative(-94.58f)
                quadToRelative(13.63f, -20.16f, 20.32f, -43.41f)
                quadToRelative(6.7f, -23.25f, 6.7f, -47.59f)
                verticalLineToRelative(-35.7f)
                quadToRelative(0.0f, -45.67f, -24.5f, -89.4f)
                quadToRelative(-24.5f, -43.73f, -72.85f, -74.88f)
                quadToRelative(49.33f, 6.24f, 94.92f, 21.33f)
                quadToRelative(45.6f, 15.1f, 84.36f, 35.86f)
                quadToRelative(36.96f, 20.0f, 56.8f, 47.21f)
                quadToRelative(19.83f, 27.2f, 19.83f, 59.4f)
                verticalLineToRelative(36.18f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                quadToRelative(-26.6f, 26.61f, -64.39f, 26.61f)
                close()
                moveTo(244.73f, 427.86f)
                quadToRelative(-48.08f, -48.08f, -48.08f, -115.99f)
                reflectiveQuadToRelative(48.08f, -115.99f)
                quadToRelative(48.07f, -48.08f, 115.99f, -48.08f)
                quadToRelative(67.91f, 0.0f, 115.99f, 48.08f)
                quadToRelative(48.07f, 48.08f, 48.07f, 115.99f)
                reflectiveQuadToRelative(-48.07f, 115.99f)
                quadToRelative(-48.08f, 48.07f, -115.99f, 48.07f)
                quadToRelative(-67.92f, 0.0f, -115.99f, -48.07f)
                close()
                moveTo(724.25f, 427.74f)
                quadToRelative(-48.18f, 48.19f, -115.84f, 48.19f)
                quadToRelative(-11.28f, 0.0f, -28.04f, -2.61f)
                quadToRelative(-16.76f, -2.62f, -28.72f, -6.1f)
                quadToRelative(27.48f, -32.48f, 42.1f, -72.4f)
                quadToRelative(14.62f, -39.92f, 14.62f, -82.92f)
                quadToRelative(0.0f, -42.99f, -14.62f, -82.94f)
                quadToRelative(-14.62f, -39.96f, -42.1f, -72.44f)
                quadToRelative(14.24f, -5.24f, 28.24f, -6.98f)
                quadToRelative(14.0f, -1.74f, 28.37f, -1.74f)
                quadToRelative(67.72f, 0.0f, 115.95f, 48.2f)
                quadToRelative(48.23f, 48.19f, 48.23f, 115.87f)
                quadToRelative(0.0f, 67.67f, -48.19f, 115.87f)
                close()
                moveTo(123.59f, 721.2f)
                horizontalLineToRelative(474.26f)
                verticalLineToRelative(-28.42f)
                quadToRelative(0.0f, -10.77f, -5.5f, -19.58f)
                quadToRelative(-5.5f, -8.81f, -14.5f, -13.7f)
                quadToRelative(-52.57f, -26.04f, -106.85f, -39.3f)
                quadToRelative(-54.28f, -13.27f, -110.28f, -13.27f)
                quadToRelative(-55.52f, 0.0f, -110.29f, 13.27f)
                quadToRelative(-54.76f, 13.26f, -106.84f, 39.3f)
                quadToRelative(-9.0f, 4.89f, -14.5f, 13.7f)
                quadToRelative(-5.5f, 8.81f, -5.5f, 19.58f)
                verticalLineToRelative(28.42f)
                close()
                moveTo(414.83f, 366.02f)
                quadToRelative(22.54f, -22.51f, 22.54f, -54.11f)
                quadToRelative(0.0f, -31.61f, -22.51f, -54.15f)
                quadToRelative(-22.5f, -22.54f, -54.1f, -22.54f)
                quadToRelative(-31.61f, 0.0f, -54.15f, 22.5f)
                quadToRelative(-22.54f, 22.51f, -22.54f, 54.11f)
                quadToRelative(0.0f, 31.6f, 22.5f, 54.15f)
                quadToRelative(22.51f, 22.54f, 54.11f, 22.54f)
                quadToRelative(31.6f, 0.0f, 54.15f, -22.5f)
                close()
                moveTo(360.72f, 721.2f)
                close()
                moveTo(360.72f, 311.87f)
                close()
            }
        }
        .build()
        return _groupW500Rounded!!
    }

private var _groupW500Rounded: ImageVector? = null
